import { DragDropContext as DragDropContext$1 } from 'react-beautiful-dnd';
var DragDropContext = DragDropContext$1;
export { DragDropContext };